const e = new URL("../../../assets/icon-metamask-BCt-YG6e.svg", import.meta.url).href;
export {
  e as default
};
//# sourceMappingURL=icon-metamask.svg.js.map
